import { objectSchema } from "vue-utils"
import { Nullable } from "../BaseEntity"

export interface MarriageSelfAssessed {
	SelfEmployed: Nullable<boolean>
	HasAccountant: Nullable<boolean>
	IsDirector: Nullable<boolean>
	LetsProperty: Nullable<boolean>
	Earns100k: Nullable<boolean>
	Earns50kPlusChildBenefit: Nullable<boolean>
	OwnsOrIsPartnerInBusiness: Nullable<boolean>
	CompletesTaxReturn: Nullable<boolean>
	Receives10kFromInvestments: Nullable<boolean>
	ReceivesIncomeFromOtherCountry: Nullable<boolean>
}

export const MarriageSelfAssessed = objectSchema<MarriageSelfAssessed>({
	SelfEmployed: Nullable(Boolean),
	HasAccountant: Nullable(Boolean),
	IsDirector: Nullable(Boolean),
	LetsProperty: Nullable(Boolean),
	Earns100k: Nullable(Boolean),
	Earns50kPlusChildBenefit: Nullable(Boolean),
	OwnsOrIsPartnerInBusiness: Nullable(Boolean),
	CompletesTaxReturn: Nullable(Boolean),
	Receives10kFromInvestments: Nullable(Boolean),
	ReceivesIncomeFromOtherCountry: Nullable(Boolean),
})
